//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  resource,
  Signal,
} from "@angular/core";
import { ActivatedRoute,  Router } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { map, Subject, takeUntil } from "rxjs";

// local imports
import { CatalogDataChangedMessage, CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";
import { Messenger } from "@app/shared";
import { Location } from "@angular/common";

@Component({
  selector: "program-property",
  standalone: false,
  templateUrl: "./program-property.component.html",
  styleUrl: "./program-property.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramPropertyComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private catalogStateService = inject(CatalogStateService);
  private messenger = inject(Messenger);

  private readonly destroying$ = new Subject<void>();

  public catalogMenuChanged: Signal<CatalogDataChangedMessage>;

  public menuLoaded = computed(() => {
    let msg = this.catalogMenuChanged();
    return !!msg;
  });

  public programId = toSignal(
     this.route.paramMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.ID)))
  );


  public programPropertyResource = resource({
    request: () => ({
      id: this.programId()
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getProgramProperty(
        request.id
      );
      return property;
    },
  });
  
  public ngOnInit(): void {
    this.catalogStateService.initialize(this.route);

    this.route.queryParamMap.pipe(
      takeUntil(this.destroying$)
    ).subscribe((params) => {
      const programId = params.get(CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID);

      if (!programId) {
        this.navigateToListPage();
      }
    });
  }

  public navigateToListPage() {
    this.router.navigate(["/catalog"], {
      queryParamsHandling: "merge",
    });
  }


  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }
}